import styled from 'styled-components';

export const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
`;

export const IntroShell = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 24px 26px;
  border-radius: 24px;
  border: 1px solid rgba(24, 90, 66, 0.08);
  background:
    radial-gradient(
      circle at 10% 10%,
      rgba(111, 188, 160, 0.16),
      transparent 28%
    ),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.92) 0%,
      rgba(247, 252, 249, 0.96) 100%
    );
  box-shadow: 0 18px 48px rgba(18, 62, 51, 0.08);

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }
`;

export const IntroHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const IntroIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #155d4b;
  background: linear-gradient(
    135deg,
    rgba(31, 114, 95, 0.16),
    rgba(53, 109, 159, 0.12)
  );
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
`;

export const IntroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const IntroBadge = styled.span`
  display: inline-flex;
  width: fit-content;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #1f725f;
  background: rgba(31, 114, 95, 0.1);
`;

export const IntroTitle = styled.h1`
  margin: 0;
  font-size: clamp(1.25rem, 2vw, 1.7rem);
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: #143d30;
`;

export const IntroDescription = styled.p`
  margin: 0;
  max-width: 62ch;
  font-size: 0.9rem;
  line-height: 1.55;
  color: #5f7f73;
`;

export const PageActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  .ant-btn {
    height: 40px;
    border-radius: 14px;
    font-size: 0.9rem;
    font-weight: 700;
  }
`;

export const PagePanel = styled.section`
  padding: 20px;
  border-radius: 24px;
  border: 1px solid rgba(24, 90, 66, 0.08);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(249, 252, 250, 0.98) 100%
  );
  box-shadow: 0 12px 28px rgba(18, 62, 51, 0.05);

  @media (max-width: 768px) {
    padding: 16px;
  }
`;
